import { REFERRAL_COLUMN } from "@/referrals/constants";

const defaultsCache = new Map<string, Array<{ id: string }>>();

/**
 * Creates a default array of objects with unique IDs
 * @param prefix - The prefix for the ID
 * @param count - The number of objects to create
 * @returns An array of objects with unique IDs
 */
export const createDefaults = (prefix: string, count: number) => {
  const cacheKey = `${prefix}-${count}`;

  if (!defaultsCache.has(cacheKey)) {
    defaultsCache.set(
      cacheKey,
      Array.from({ length: count }, (_, i) => ({ id: `${prefix}-${i + 1}` })),
    );
  }

  return defaultsCache.get(cacheKey)!;
};

export const DEFAULT_COLUMN_COUNT = 3;

/**
 * Skeleton loading defaults for referral kanban board
 */
export const LOADING_DEFAULTS = {
  [REFERRAL_COLUMN.new]: () => createDefaults("placeholder-new", 5),
  [REFERRAL_COLUMN.inProgress]: () =>
    createDefaults("placeholder-in-progress", DEFAULT_COLUMN_COUNT),
  [REFERRAL_COLUMN.scheduled]: () => createDefaults("placeholder-scheduled", 2),
  [REFERRAL_COLUMN.closed]: () =>
    createDefaults("placeholder-closed", DEFAULT_COLUMN_COUNT),
} as const;
